import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as generalActions from '../../../../../actions/generalAction';
import ExchangeRates from './ExchangeRates';

const mapStateToProps = state => {
    return {
        generalState: state.generalReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getExchangeRates: () => dispatch(generalActions.getListExchangeRates()),
        setExchangeRates: (exchangeRates) => dispatch(generalActions.setListExchangeRates(exchangeRates)),
        updateExchangeRate: (exchangeRate) => dispatch(generalActions.updateExchangeRate(exchangeRate)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ExchangeRates));
